import React, { Component } from 'react';

import Content from '../../components/Content';
import HomeCarouselLogo from '../../components/home/CarouselLogo';
import { features, accordions } from '../../services/a1';

class Home extends Component {
  componentDidMount() {
    document.title = 'A1 Xplore TV GO';
  }

  render() {
    return (
      <>
        <Content
          className="a1now-home-parallax a1now-bg-parallax"
          style={{
            backgroundImage: 'url(https://media.a1.bg/xploretv/uploads/2019/10/home-01.jpg)',
          }}
          resource="HomeCarousel"
        />

        <div className="a1now-content-area">
          <Content
            resource="HomeFeatures"
            callback={() => {
              features();
            }}
          />

          <HomeCarouselLogo />

          <Content resource="HomeTeasers" />

          <Content resource="HomeDevices" />

          <Content resource="HomePackages" />

          <Content
            resource="HomeFAQ"
            callback={() => {
              accordions();
            }}
          />
        </div>
      </>
    );
  }
}

export default Home;
